import React from 'react';
import { Card, Table, Typography, Space, Tag } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { usePermission } from '../hooks/usePermission';

const { Title, Text } = Typography;

const DebugPermissions: React.FC = () => {
  const { user, permissions } = useAuth();
  const { isAdmin } = usePermission();

  const columns = [
    {
      title: '權限代碼',
      dataIndex: 'permission',
      key: 'permission',
    },
    {
      title: '模組',
      dataIndex: 'module',
      key: 'module',
      render: (text: string) => <Tag color="blue">{text}</Tag>,
    },
    {
      title: '動作',
      dataIndex: 'action',
      key: 'action',
      render: (text: string) => <Tag color="green">{text}</Tag>,
    },
  ];

  const permissionData = permissions.map((perm, index) => {
    const parts = perm.split('_');
    const action = parts.pop() || '';
    const module = parts.join('_');
    
    return {
      key: index,
      permission: perm,
      module: module,
      action: action,
    };
  });

  return (
    <div style={{ padding: 24 }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card>
          <Title level={4}>使用者資訊</Title>
          <Space direction="vertical">
            <Text>使用者ID: {user?.userId}</Text>
            <Text>使用者名稱: {user?.userName}</Text>
            <Text>是否為管理員: {isAdmin ? <Tag color="red">是</Tag> : <Tag>否</Tag>}</Text>
            <Text>權限總數: {permissions.length}</Text>
          </Space>
        </Card>

        <Card>
          <Title level={4}>權限列表</Title>
          <Table 
            columns={columns} 
            dataSource={permissionData} 
            pagination={false}
            size="small"
          />
        </Card>

        <Card>
          <Title level={4}>原始權限陣列</Title>
          <pre style={{ maxHeight: 300, overflow: 'auto' }}>
            {JSON.stringify(permissions, null, 2)}
          </pre>
        </Card>
      </Space>
    </div>
  );
};

export default DebugPermissions;